import {KTSVG} from 'helpers'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {DiscountType} from 'models/OrderManagement'
import {formatNumberForDisplay} from 'utils/helper'

export const SummaryRow = ({
 label,
 subtitle,
 children,
}: {
 label: string
 subtitle?: React.ReactNode
 children: React.ReactNode
}) => (
 <div className='flex justify-between items-center px-6 py-3 min-h-[52px] border-b border-[#E6EBF0] last:border-b-0'>
  <div>
   <p className='text-[#33393D] text-[15px] font-medium mb-0.5'>
    {label}
   </p>
   {subtitle}
  </div>
  <div className='flex items-center gap-2 justify-end'>
   {children}
  </div>
 </div>
)

export const SummaryAmount = ({
 value,
 previousValue,
 showStrikethrough,
}: {
 value: number
 previousValue?: number
 showStrikethrough?: boolean
}) => (
 <>
  {showStrikethrough &&
   previousValue != null &&
   Number(previousValue) !== value && (
    <span className='line-through text-[#9AA0A6] text-[14px]'>
     {formatNumberForDisplay(previousValue)}
    </span>
   )}
  <span className='text-[#33393D] text-[15px] font-semibold'>
   {formatNumberForDisplay(value)}
  </span>
 </>
)

export const DiscountControls = ({
 discountValue,
 discountEditable,
 onEditDiscount,
}: {
 discountValue: number
 discountEditable: boolean
 onEditDiscount: () => void
}) => {
 const {t} = useTranslation()

 return (
  <div className='flex items-center gap-2'>
   <div className='min-w-[72px] h-[36px] px-3 rounded-md bg-[#EEF2F6] flex items-center justify-center text-sm font-medium text-[#33393D]'>
    {formatNumberForDisplay(discountValue)}
   </div>
   {discountEditable && (
    <button
     type='button'
     onClick={onEditDiscount}
     className='text-[#4E83E4]'
     aria-label={t('orderManagement.editDiscount')}
    >
     <KTSVG
      path={`/media/icons/pencil.svg`}
      svgClassName={`w-6 h-6 text-white p-[2px]`}
     />
    </button>
   )}
  </div>
 )
}

export const DiscountSummaryRow = ({
 discountType,
 discountAmount,
 discountValue,
 discountEditable,
 onEditDiscount,
}: {
 discountType: DiscountType
 discountAmount: number
 discountValue: number
 discountEditable: boolean
 onEditDiscount: () => void
}) => {
 const {t} = useTranslation()

 const discountLabel =
  discountType === 'PERCENTAGE'
   ? t('orderManagement.discountAppliedInPercent')
   : t('orderManagement.discountAppliedInRupees')

 const discountSubtitle = (
  <p className='text-[#80868C] text-[12px]'>
   {t('orderManagement.discountValueLabel', {
    value: formatNumberForDisplay(discountAmount),
   })}
  </p>
 )

 return (
  <SummaryRow
   label={discountLabel}
   subtitle={discountSubtitle}
  >
   <DiscountControls
    discountValue={discountValue}
    discountEditable={discountEditable}
    onEditDiscount={onEditDiscount}
   />
  </SummaryRow>
 )
}
